// Phone + email validation. Kenya-only for now — every number resolves to +254
// (a country selector will come later, when we expand). A valid mobile number is
// +254 followed by 9 subscriber digits (12 digits in total), starting 7 or 1.

const KE_E164 = /^\+254[71]\d{8}$/;
const EMAIL = /^[\w.+-]+@[\w-]+\.[\w.-]+$/;

/** Normalise common Kenyan inputs to `+254XXXXXXXXX`, or null if it can't be one. */
export function normalizeKenyanPhone(raw: string): string | null {
  let s = (raw ?? '').replace(/[^\d+]/g, '');
  if (s.startsWith('+')) s = s.slice(1);
  if (s.startsWith('254')) s = s.slice(3);
  else if (s.startsWith('0')) s = s.slice(1);
  if (!/^[71]\d{8}$/.test(s)) return null;
  return `+254${s}`;
}

/** True when the value is a full, valid Kenyan E.164 mobile number. */
export function isValidKenyanPhone(value: string): boolean {
  return KE_E164.test(value) || normalizeKenyanPhone(value) !== null;
}

export function isValidEmail(value: string): boolean {
  return EMAIL.test((value ?? '').trim());
}
